// extracted by mini-css-extract-plugin
module.exports = {"accordion":"Faq_accordion__HusqB"};